module.exports = __webpack_public_path__ + "static/media/06.b9b47d6f.png";